module.exports = __webpack_public_path__ + "static/media/iPhone11.b11b5656.png";